const LinkClicksStatCard = ({ title, description, value, icon: Icon }) => (
  <article className="position-relative overflow-hidden bg-white rounded-4 p-3 p-md-4 h-100">
    <div className="position-relative z-1">
      <h2 className="fs-4 fw-bold mb-2">{title}</h2>
      <p className="fs-6 text-gray mb-4">{description}</p>
      <div className="fs-4 fw-bold">{value}</div>
    </div>
    <Icon
      className="link-clicks-stat-icon position-absolute top-50 end-0 translate-middle-y me-5 text-lightGray"
      aria-hidden="true"
    />
  </article>
);

export default LinkClicksStatCard;
